var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "telnyx-cdr" } },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "a-button",
              {
                attrs: { loading: _vm.loading, icon: "reload" },
                on: { click: _vm.refreshData },
              },
              [_vm._v(" Yenile ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  loading: _vm.loading,
                  icon: "download",
                },
                on: { click: _vm.exportRecordings },
              },
              [_vm._v("\n                Dışa Aktar\n            ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c(
          "div",
          { staticClass: "toolbar-filter" },
          [
            _c("a-input-search", {
              staticClass: "search-input",
              staticStyle: { width: "300px" },
              attrs: {
                placeholder:
                  "Call Leg ID, Session ID veya Connection ID ile ara...",
                loading: _vm.loading,
              },
              on: { search: _vm.onSearch },
              model: {
                value: _vm.searchText,
                callback: function ($$v) {
                  _vm.searchText = $$v
                },
                expression: "searchText",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "date-filter-inline" },
              [
                _c("span", { staticClass: "date-label" }, [
                  _vm._v("Tarih Aralığı:"),
                ]),
                _vm._v(" "),
                _c("a-range-picker", {
                  staticStyle: { width: "250px" },
                  attrs: {
                    format: "DD.MM.YYYY",
                    placeholder: ["Başlangıç", "Bitiş"],
                  },
                  on: { change: _vm.onDateRangeChange },
                  model: {
                    value: _vm.dateRange,
                    callback: function ($$v) {
                      _vm.dateRange = $$v
                    },
                    expression: "dateRange",
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "date-required" }, [_vm._v("*")]),
              ],
              1
            ),
            _vm._v(" "),
            _c("CommonFilterTool", {
              attrs: {
                "keep-state-on-query-params": false,
                "filter-meta": _vm.filterMetas,
                "label-formatter": _vm.filterLabelFormatter,
                "show-clear-all": _vm.breakdownFilter.length > 0,
              },
              on: {
                addFilter: _vm.addFilter,
                removeFilter: _vm.removeFilter,
                clearAll: _vm.clearFilters,
              },
              model: {
                value: _vm.breakdownFilter,
                callback: function ($$v) {
                  _vm.breakdownFilter = $$v
                },
                expression: "breakdownFilter",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toolbar-actions" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "statistics" }, [
        _c("div", { staticClass: "stats-grid" }, [
          _c("div", { staticClass: "stat-card total-recordings" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.totalRecordings)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Toplam Kayıt"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card inbound-recordings" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.inboundRecordings)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Gelen Aramalar"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-percentage" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.statistics.totalRecordings > 0
                        ? Math.round(
                            (_vm.statistics.inboundRecordings /
                              _vm.statistics.totalRecordings) *
                              100
                          )
                        : 0
                    ) +
                    "%\n                    "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card outbound-recordings" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.outboundRecordings)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Giden Aramalar"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-percentage" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(
                      _vm.statistics.totalRecordings > 0
                        ? Math.round(
                            (_vm.statistics.outboundRecordings /
                              _vm.statistics.totalRecordings) *
                              100
                          )
                        : 0
                    ) +
                    "%\n                    "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "stat-card average-duration" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "stat-content" }, [
              _c("div", { staticClass: "stat-value" }, [
                _vm._v(_vm._s(_vm.statistics.averageDuration)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-label" }, [
                _vm._v("Ortalama Süre"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "stat-unit" }, [_vm._v("saniye")]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("SupsisTable", {
            attrs: {
              columns: _vm.getCols(),
              rows: _vm.recordingData,
              loading: _vm.loading,
              "top-pagination": "",
              "bottom-pagination": "",
              "pagination-cursor": _vm.pagination,
              options: {
                fixedHeader: true,
                borderX: true,
                borderY: true,
              },
              "pagination-options": [10, 20, 30, 40, 50, 100, 200, 250],
            },
            on: { "cursor-changed": _vm.onPaginationChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Kayıt Detayları", footer: null, width: "700px" },
          model: {
            value: _vm.showDetailModal,
            callback: function ($$v) {
              _vm.showDetailModal = $$v
            },
            expression: "showDetailModal",
          },
        },
        [
          _vm.selectedRecording
            ? _c(
                "div",
                [
                  _c(
                    "a-descriptions",
                    { attrs: { column: 2, bordered: "", size: "small" } },
                    [
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Recording ID" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedRecording.id) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Oluşturma Tarihi" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm
                                  .$moment(_vm.selectedRecording.created_at)
                                  .format("DD.MM.YYYY HH:mm:ss")
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Yön" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getDirectionColor(
                                  _vm.determineDirection(_vm.selectedRecording)
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getDirectionTextFromDirection(
                                      _vm.determineDirection(
                                        _vm.selectedRecording
                                      )
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Arayan (From)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedRecording.from || "-") +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Aranan (To)" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedRecording.to || "-") +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Durum" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getStatusColor(
                                  _vm.selectedRecording.status
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getStatusText(
                                      _vm.selectedRecording.status
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Kaynak" } },
                        [
                          _c(
                            "a-tag",
                            {
                              attrs: {
                                color: _vm.getSourceColor(
                                  _vm.selectedRecording.source
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.getSourceText(
                                      _vm.selectedRecording.source
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-descriptions-item", { attrs: { label: "Süre" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.formatDuration(
                                _vm.selectedRecording.duration_millis
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Dosya Boyutu" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.formatFileSize(
                                  _vm.selectedRecording.file_size
                                )
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-descriptions-item",
                        { attrs: { label: "Kanal Sayısı" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.selectedRecording.channels) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedRecording.conference_id
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Conference ID" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.selectedRecording.conference_id) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.call_leg_id
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Call Leg ID" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.selectedRecording.call_leg_id) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.call_session_id
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Call Session ID" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.selectedRecording.call_session_id
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.connection_id
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Connection ID" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.selectedRecording.connection_id) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.initiated_by
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Başlatan" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.selectedRecording.initiated_by) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.recording_started_at
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Kayıt Başlangıç" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm
                                      .$moment(
                                        _vm.selectedRecording
                                          .recording_started_at
                                      )
                                      .format("DD.MM.YYYY HH:mm:ss")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.recording_ended_at
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Kayıt Bitiş" } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm
                                      .$moment(
                                        _vm.selectedRecording.recording_ended_at
                                      )
                                      .format("DD.MM.YYYY HH:mm:ss")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedRecording.download_urls &&
                      Object.keys(_vm.selectedRecording.download_urls).length >
                        0
                        ? _c(
                            "a-descriptions-item",
                            { attrs: { label: "Download URLs", span: "2" } },
                            _vm._l(
                              _vm.selectedRecording.download_urls,
                              function (url, format) {
                                return _c(
                                  "div",
                                  { key: format },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          icon: "play-circle",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.playRecording(
                                              _vm.selectedRecording,
                                              format
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(format.toUpperCase()) +
                                            " Oynat\n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.showAudioPlayer
        ? _c("div", { staticClass: "audio-player-dock" }, [
            _c("div", { staticClass: "audio-player-container" }, [
              _c("div", { staticClass: "audio-player-info" }, [
                _c("i", { staticClass: "material-icons audio-icon pulse" }, [
                  _vm._v("music_note"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "audio-title-container" }, [
                  _c("div", { staticClass: "now-playing" }, [
                    _vm._v("Şimdi Çalıyor"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "audio-title" }, [
                    _vm._v(_vm._s(_vm.currentPlayingRecordName)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "audio-player-wrapper" }, [
                _c("audio", {
                  ref: "audioPlayer",
                  attrs: {
                    controls: "",
                    src: _vm.currentPlayingRecordURL,
                    autoplay: "",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "audio-player-controls" },
                [
                  _c("a-button", {
                    attrs: {
                      type: "danger",
                      shape: "circle",
                      icon: "close",
                      size: "large",
                    },
                    on: { click: _vm.closeAudioPlayer },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left" }, [
      _c("h3", [_vm._v("Arama Kayıtları (Recordings)")]),
      _vm._v(" "),
      _c("p", [_vm._v("Telnyx arama kayıtlarını görüntüleyin")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("record_voice_over")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call_received")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("call_made")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("timer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }